import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AmenityPicker } from "@/components/AmenityPicker";
import { ImageUploader } from "@/components/ImageUploader";
import { PostedPropertyCard } from "@/components/landlord/PostedPropertyCard";

const EMPTY = { address: "", city: "", rent: "", bedrooms: 1, bathrooms: 1, lease_length_months: 12, available_date: "", description: "", amenities: [], images: [] };

export function PropertiesTab({ properties, onCreated, onViewMatches }) {
  const [prop, setProp] = useState(EMPTY);

  const createProperty = async (e) => {
    e.preventDefault();
    try {
      await api.post("/properties", { ...prop, rent: Number(prop.rent), bedrooms: Number(prop.bedrooms), bathrooms: Number(prop.bathrooms), lease_length_months: Number(prop.lease_length_months) });
      toast.success("Property posted");
      setProp(EMPTY);
      onCreated();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <form onSubmit={createProperty} className="bg-white border border-border rounded-sm p-6 space-y-3">
        <h3 className="font-display text-lg font-semibold">Post a property</h3>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Address</Label><Input data-testid="prop-address" required value={prop.address} onChange={(e) => setProp({ ...prop, address: e.target.value })} /></div>
          <div><Label>City</Label><Input data-testid="prop-city" required value={prop.city} onChange={(e) => setProp({ ...prop, city: e.target.value })} /></div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div><Label>Rent</Label><Input data-testid="prop-rent" type="number" required value={prop.rent} onChange={(e) => setProp({ ...prop, rent: e.target.value })} /></div>
          <div><Label>Beds</Label><Input data-testid="prop-beds" type="number" value={prop.bedrooms} onChange={(e) => setProp({ ...prop, bedrooms: e.target.value })} /></div>
          <div><Label>Baths</Label><Input data-testid="prop-baths" type="number" value={prop.bathrooms} onChange={(e) => setProp({ ...prop, bathrooms: e.target.value })} /></div>
          <div><Label>Lease(mo)</Label><Input data-testid="prop-lease" type="number" value={prop.lease_length_months} onChange={(e) => setProp({ ...prop, lease_length_months: e.target.value })} /></div>
        </div>
        <div><Label>Available date</Label><Input data-testid="prop-date" type="date" value={prop.available_date} onChange={(e) => setProp({ ...prop, available_date: e.target.value })} /></div>
        <div>
          <Label>Photos</Label>
          <div className="mt-2"><ImageUploader value={prop.images} onChange={(v) => setProp({ ...prop, images: v })} multiple featured testid="prop-photos" /></div>
        </div>
        <div>
          <Label>Amenities</Label>
          <div className="mt-2"><AmenityPicker value={prop.amenities} onChange={(v) => setProp({ ...prop, amenities: v })} testidPrefix="prop-amenity" /></div>
        </div>
        <Button type="submit" className="w-full" data-testid="prop-submit">Post & auto-match</Button>
      </form>
      <div className="space-y-3">
        <h3 className="font-display text-lg font-semibold">Your properties</h3>
        {properties.length === 0 && <div className="text-sm text-muted-foreground">No properties yet.</div>}
        {properties.map((p) => (
          <PostedPropertyCard key={p.id} p={p} onViewMatches={onViewMatches} onChanged={onCreated} />
        ))}
      </div>
    </div>
  );
}
